/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsVideo = {
    init: function ($section) {
  
      // Add settings from schema to current object
      window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));
  
      // Selectors
      const $videoElement = $section.find('[data-video-element]');
      const $playIcon = $section.find('.plyr__control--overlaid');
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
      const $imageElement = $section.find('[data-image-element]');
  
      // Load video if the media has been added
      if (this.iframe_video || this.html5_video) {
        this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
      } else {
        $imageElement.show();
      }
  
    },
    loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
      const player = new Plyr(`.video-${this.id}`, {
        controls: videoControls,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
  
      player.muted = this.mute;
      player.ratio = this.aspect_ratio;
  
      // ================== 处理 window_autoloop & autoplay ==================
      if (this.autoplay || this.window_autoloop) {
        // 浏览器要求：自动播放必须静音
        player.muted = true;
      }
  
      if (this.window_autoloop) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              player.play().catch(err => {
                console.warn("Autoplay blocked, waiting for user interaction:", err);
              });
            } else {
              player.pause();
            }
          });
        }, { threshold: 0.5 });
        observer.observe($videoElement[0]);
      }
  
      // 监听一次用户交互 → 如果不是静音设置，就恢复声音
      document.addEventListener("click", () => {
        if (!this.mute) {
          player.muted = false;
        }
      }, { once: true });
      // ===============================================================
  
      // If autoplay enabled, hide image and text
      if (this.autoplay) {
        player.autoplay = true;
        $imageElement.hide();
        $videoTextContainer.hide();
        $videoElement.show();
      } else {
        if (this.poster) {
          $videoElement.hide();
          $imageElement.show();
          $videoTextContainer.show();
        } else {
          $imageElement.hide();
          $videoElement.show();
          $videoTextContainer.show();
        }
      }
  
      // Play button click
      if (this.button && $playButton.length) {
        $playButton.off('click').on('click', () => {
          player.play();
        });
      }
  
      // Click text container to play
      if (!this.button && $videoTextContainer.length) {
        $videoTextContainer.off('click').on('click', () => {
          player.play();
        });
      }
  
      // Mobile: clicking image wrapper plays video
      if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media').length) {
        $imageElement.off('click').on('click', () => {
          player.play();
        });
      }
  
      // Player events
      player.on('ready', () => {
        if ($playButton.length) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }
      });
  
      player.on('play', () => {
        $videoElement.show();
        $imageElement.hide();
        $videoTextContainer.hide();
        $playIcon.hide();
      });
  
      player.on('pause', () => {
        if (!$playButton.length) {
          $playIcon.show();
        }
      });
  
    },
    unload: function($section) {
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
      const $imageElement = $section.find('[data-image-element]');
  
      $playButton.off();
      $videoTextContainer.off();
      $imageElement.off();
    }
  }
  
/******/ })()
;
